import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux'

import { domain, domainConfig, getPromo } from 'src/helpers/domainConfig'
import api from 'src/actions/api'

class Component extends React.Component {
  
  componentWillMount() {
    const initialState = {
      login: "",
      password: "",
      password_retype: "",
      firstname: "",
      skype: ""
    }

    this.setState(initialState)
  }

  submit = (e) => {    
    e.preventDefault()   
    if (this.props.login.loading) {
      return
    }
    const { login, password, password_retype, skype, firstname } = this.state;
    if (!login || !password) {
      return
    }
    if (this.props.isSignup) {
      // if (password != password_retype) {
      //   this.setState({error: "Password does not match"})
      //   return
      // }
      if (password.length < 6) {
        this.setState({error: "Password must be at least 6 characters"})
        return
      }      
      if (!skype || !firstname) {
        return
      }
      this.setState({error: ""})
      let query = this.props.query
      this.props.api("auth/signup",{
        username: login,
        password: password,
        firstname: firstname,
        skype: skype,
        mid: query.mid || 0,
        oid: query.oid || 0,
        aid: query.aid || 5,
        domain: domain
      })
    } else {
      this.props.api("auth/login",{
        username: login,
        password: password
      })
    }
  }

  handleChange = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }  
 
  render() {        
    let error = this.props.login.error 
      || this.props.signup.error 
      || this.props.autologin.error 
      || this.props.sid.error 
      || this.props.logback.error
      || this.state.error 
      || "";
    let badCredentials = error.toString() == "Bad credentials";
    let isSignup = this.props.isSignup
    var pageConfig = domainConfig;

    return (
      <form onSubmit={this.submit} class="box p-3 border rounded mb-2 login-form-height">
        <h4 class="signup-title mb-3">{isSignup ? "Sign up" : "Sign in"}</h4>
        {isSignup && 
        <div class="form-group">
          <input 
            name="firstname"
            autoComplete="firstname"
            type="text"
            class="form-control form-control-lg"
            placeholder="First name"
            required
            value={this.state.firstname} 
            onChange={this.handleChange} />
        </div>
        }
        {isSignup && 
        <div class="form-group">
          <input 
            name="skype"
            autoComplete="skype"
            type="text"
            class="form-control form-control-lg"
            placeholder="Telegram/Teams"
            required
            value={this.state.skype} 
            onChange={this.handleChange} />
        </div>
        }

        <div class="form-group">
          <input 
            name="login"
            type={isSignup ? "email" : "text"}
            autoComplete="email"
            required
            class="form-control form-control-lg"
            placeholder="Enter email"
            value={this.state.login} 
            onChange={this.handleChange} />
        </div>    
        <div class="form-group">
          <input 
            name="password"
            autoComplete="password"
            type="password"
            required
            class="form-control form-control-lg"
            placeholder="Password"
            value={this.state.password}
            onChange={this.handleChange} />            
        </div>    
        {isSignup && false &&
        <div class="form-group">
          <input 
            name="password_retype"
            autoComplete="password_retype"
            type="password"
            required
            class="form-control form-control-lg"
            placeholder="Retype password"
            value={this.state.password_retype}
            onChange={this.handleChange} />
        </div>    
        }            
        {error && <small id="passwordHelp" class="form-text text-muted mb-2">{error}</small>}
        {!this.props.login.loading && 
          <button type="submit" class="btn btn-lg primary login-submit">
            {isSignup 
              ? pageConfig.signupButton 
              : "Sign in"
            }
          </button>
        }
        {this.props.login.loading && 
          <small>Authenticating...</small>
        }                 
      </form>    
    )    
  }
}

export default connect(
  function (state) {
    return {
      login: state.api.auth_login || state.api.initial,
      signup: state.api.auth_signup || state.api.initial,
      autologin: state.api.auth_autologin || state.api.initial,
      sid: state.api.auth_sid || state.api.initial,
      logback: state.api.auth_logback || state.api.initial
    };
  }, {api})(Component)